<template>
    <div class="RenamingComponent">

        <b-form autocomplete="off">

            <b-form-group id="input-group-NewName" :label="lang.label_NewName" label-for="input-2">
                <b-form-input id="input-NewName" v-model="form.NewName" :placeholder="lang.placeholder_NewName"
                    size="sm" required aria-describedby="input-NewName-feedback" :state="validation_NewName">
                </b-form-input>

                <b-form-invalid-feedback id="input-FirstName-feedback" :state="validation_NewName">
                    {{ lang.validinfo_NewName }}
                </b-form-invalid-feedback>
            </b-form-group>
            <p>{{lang.infotext_1}}</p>



        </b-form>
    </div>
</template>

<script>



export default {
    name: "RenamingComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {
            form: {

                NewName: ""
            },
            lengthTrigger: false
            
        }
    },
    computed: {
        validation_NewName() {
            
            if (this.form.NewName.length == 0) {
                if (this.lengthTrigger) {
                    return false;
                }
                return null;
            }

            let index = this.form.NewName.indexOf("\\")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("/")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf(":")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("*")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("?")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("\"")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("<")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf(">")
            if (index > -1) {
                return false;
            }
            index = this.form.NewName.indexOf("|")
            if (index > -1) {
                return false;
            }

            
            return this.form.NewName.length > 0
        },
        
    },
    created() {


    },
    updated() {
        if (this.form.NewName.length > 0) {
            this.lengthTrigger = true;
        }
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_renaming", this.form);
        console.log(this.form)
    },
    methods: {

    }
}
</script>
<style lang="scss">
    .RenamingComponent {
        
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/RenamingComponent.vue